import React, { Component } from 'react';
import { MathUtils, MediaMarkdownListSection } from "microsite_utils";
// import { Container, Row, Col, Card, Button, Modal, Table, Badge } from "react-bootstrap";
import {SignupHero,SignupHeroData, EventCardData} from './SignupHero';
import {HeroSectionData, VideoIntro} from './VideoIntro';
import VideoIntroLanding from './VideoIntroLanding';
import MarketingLander from './MarketingLander';
import FromThisToThis from './FromThisToThis.js';
import {WorkshopAgenda, WorkshopSectionData} from './WorkshopAgenda';
import LearningOutcomes from './LearningOutcomes';
import LocationDetails from './LocationDetails';
import CurriculumSection from './CurriculumSection';
import {Markdown, MarkdownData} from './Markdown.js'; 
import JsonService from './JsonService';
import {VideoMenuBinder,VideoMenuBinderData} from './VideoMenuBinder.js';
import { BaseData, Any, List, ModernFloatRangeExampleClass } from './BaseData.js';
import { RenderControlData } from './RenderControlData.js';
import { SocialsBar,SocialsBarData } from './SocialsBar.js';
import { RegistrationForm,RegistrationFormCardData } from './RegistrationForm.js';
import { HeroBanner,HeroBannerData } from './HeroBanner.js';
import { ArtlabBanner,ArtlabBannerData } from './ArtlabBanner.js';
import { CourseOutcomes,CourseOutcomesData } from './CourseOutcomes.js';
import { ProductShotSection,ProductShotSectionData } from './ProductShotSection.js';
import { EventCard } from './EventCard.js';

// Style
const spine = {
  position: 'absolute',
  left: '0.5rem',
  top: '0.5rem',
  bottom: '0.5rem',
  width: '2px',
  backgroundColor: '#0d6efd',
};

const SECTION_REGISTRY = {
  event_card: { Ctor: EventCardData, Component: EventCard },
  registration_form: { Ctor: RegistrationFormCardData, Component: RegistrationForm },
  socials_bar: { Ctor: SocialsBarData, Component: SocialsBar },
  video_menu_binder: { Ctor: VideoMenuBinderData, Component: VideoMenuBinder },
  video_intro_landing: { Ctor: RenderControlData, Component: VideoIntroLanding },
  hero: { Ctor: HeroSectionData, Component: VideoIntro },
  hero_landing: { Ctor: HeroSectionData, Component: MarketingLander },
  signup_hero: { Ctor: SignupHeroData, Component: SignupHero },
  hero_banner:{ Ctor: HeroBannerData, Component: HeroBanner },
  workshop: { Ctor: WorkshopSectionData, Component: WorkshopAgenda },
  from_this_to_this: { Ctor: RenderControlData, Component: FromThisToThis },
  artlab_banner: { Ctor: ArtlabBannerData, Component: ArtlabBanner },
  course_outcomes: { Ctor: CourseOutcomesData, Component: CourseOutcomes },
  product_shot_section: { Ctor: ProductShotSectionData, Component: ProductShotSection },
  media_markdown_list: { Ctor: RenderControlData, Component: MediaMarkdownListSection },
  markdown: {
    Ctor: MarkdownData,
    render: (section, key) => {
      if (!section?.content) return <div key={key} className="section-error">Missing markdown content</div>;
      return <Markdown key={key} md={section.content} />;
    },
  },

  learning_outcomes: {
    Ctor: RenderControlData,
    render: (_section, key, content) => <LearningOutcomes key={key} outcomes={content.outcomes} />,
  },
};


class SectionFactory
{
   mkSectionInstance(s) {
    const t = s && s.render_control_type ? s.render_control_type : null;

    if (t === 'signup_hero') { // keep special-case (cards recursion)
      const inst = new SignupHeroData(s);
      inst.cards = (inst.cards || []).map((c) => this.mkSectionInstance(c));
      return inst;
    }

    const entry = t ? SECTION_REGISTRY[t] : null; 
    const Ctor = entry ? entry.Ctor : null;       
    if (Ctor) {                             
      return new Ctor(s);
    }

    return new RenderControlData(s);
  }
}


export default function SectionCreate({ content_url, children }) {
  const [content, setContent] = React.useState(null);
  const [sections, setSections] = React.useState([]);
  const [error, setError] = React.useState(null);
  // const GLOBAL_CONTENT_URL = '/landers/artlab.json';

  React.useEffect(() => {
    const ctrl = new AbortController();
    (async () => {
      try {
        // 1) load content.json
        const global = await JsonService.fetchJson({ url: content_url, signal: ctrl.signal, cache: 'no-store' });
        setContent(global);

        // 2) load each section json listed in content.sections
        const urls = Array.isArray(global.sections) ? global.sections : [];
        if (!urls.length) throw new Error(`No sections listed in lander: ${content_url}`);
        const rawSections = await Promise.all(
          urls.map((u) => JsonService.fetchJson({ url: u, signal: ctrl.signal, cache: 'no-store' }))
        );
        const factory = new SectionFactory(); // NEW
        // 3) parse into typed section instances
        setSections(rawSections.map(factory.mkSectionInstance.bind(factory))); 
      } catch (e) {
        if (e.name !== 'AbortError') setError(e);
      }
    })();
    return () => ctrl.abort();
  }, []);

  if (error) return <div>Error: {String(error)}</div>;
  if (!content || sections.length === 0) return <div>Loading…</div>;

  const calculateTestResult = MathUtils.add(2, 3);
  return (
    <div>
      {sections.map((section, i) => {
            const t = section && section.render_control_type ? section.render_control_type : null;
            const entry = t ? SECTION_REGISTRY[t] : null;
            const type = t || "unknown";
            if (!entry) return <div key={i} className="section-error">Missing section type: {type}</div>;

            if (entry.render) {
              return entry.render(section, i, content);
            }

            const C = entry.Component;
            if (!C) return <div key={i} className="section-error">No renderer for section type: {type}</div>;

            return <C key={i} section={section} />;
      })}
      {children}
    </div>
  );
}





////
